import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberSetupPage from "@/pages/member/MemberSetupPage";

export const Route = createFileRoute("/member/setup")({
  head: () => pageHead("Member Setup", "Set up your AI Innovation Network profile.", "/member/setup", true),
  component: MemberSetupPage,
});
